import { h } from "preact";
import { NavLink } from "react-router-dom";

import Icon from "./Icon.jsx";
import { classNames } from "../helpers";

export default function SidebarLink(props) {
  return (
    <NavLink
      className={({ isActive }) =>
        [
          "sidebar-link",
          props.class,
          isActive ? "sidebar-link--active" : "",
        ].join(" ")
      }
      to={props.href}
    >
      <span class="sidebar-link__icon">
        <Icon>{props.icon}</Icon>
      </span>
      <span class="sidebar-link__title">{props.alt}</span>
    </NavLink>
  );
}
